import React, { useEffect } from 'react';
import { Route, Switch as Switchs } from 'react-router-dom';
import { isMobile } from 'react-device-detect';
import Progress from './Progress';
import ProfileSections from './ProfileSections';
import MainTitle from '../../components/MainTitle';
import ButtonBase from '../../components/Buttons/ButtonBase';
import { makeStyles } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import CardProfile from '../../components/Profile/Card/';
import { Formik } from 'formik';
import { validationContactInfoAbout } from '../../utils/validations';
import ExperienceForm from '../../components/Forms/Perfil/Experience';
import ContactForm from '../../components/Forms/Perfil/Contact';
import { updateQualification } from './../../store/actions/UserAction';
import { connect } from 'react-redux';


import './index.scss';
import { flex } from 'styled-system';
import SideNav from '../../components/Profile/SideNav';
import TopNav from '../../components/Profile/TopNav';
import {
  Link,
  DirectLink,
  Element,
  Events,
  animateScroll as scroll,
  scrollSpy,
  scroller,
} from 'react-scroll';

import * as ROUTES from '../../routes/';
import { Switch } from '@material-ui/core';

const preview = '/img/icons/preview.svg';

const useStyles = makeStyles({
  previewButton: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
    '@media (max-width: 1000px)': {
      width: '100%',
    },
  },
});

const Profile = (props) => {
  const { authClient, uid, updateQualification } = props
  const classes = useStyles();
  const tabletSize = useMediaQuery('(max-width:768px)');


  const handleSubmit = (values, { setSubmitting, setFieldError }) => {
    setSubmitting(false);
  };

  useEffect(() => {
    if (authClient && authClient.analytics.opinion.qualification <= 4) {
      const boolValues = false
      updateQualification(uid, boolValues)
    } else {
      const boolValues = true
      updateQualification(uid, boolValues)
    }
  }, [])

  return (
    <>
      {/* componente Profile */}

      <div className="profile">
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            padding: tabletSize ? '0 24px' : '0',
            marginBottom: 24,
          }}
        >
          <div style={{ maxWidth: 520 }}>
            <MainTitle
              title="Perfil"
              subtitle={authClient && authClient.role === 'lawFirm' ?
                'Edita y completa los datos del despacho. Recuerda que entré más información registres, mayor visibilidad tendrán dentro de la plataforma.' :
                'Edita y completa tus datos. Recuerda que entre más información registres, mayor visibilidad tendrás dentro de la plataforma.'
              }
            />
          </div>
          <div className={classes.previewButton}>
            <ButtonBase
            disable={true}
              variant="primary"
              style={{
                width: 197,
                marginTop: 30,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-around',
              }}
              direction='/preview'
            >
              <img src={preview} alt="" />
              Previsualización
            </ButtonBase>
          </div>
        </div>
        <div className="containerProfile">
          <div className="workArea">
            <div className="menuProfile">
              {tabletSize ? <TopNav /> : <SideNav />}
            </div>
            
            <Route
              exact
              path={ROUTES.PROFILE}
              component={ProfileSections}
            />

            <Route
              exact
              path={ROUTES.PROFILEPROGRESS}
              component={Progress}
            />
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  authClient: state.authClient,
  uid: state.authClient.uid,
})

const mapDispatchToProps = dispatch => ({
  updateQualification: (uid, boolValues) => dispatch(updateQualification(uid, boolValues))
})

export default connect(mapStateToProps, mapDispatchToProps)(Profile);
